export default __webpack_public_path__ + "static/media/example-horse.6f343c52.png";